// Recovered compiled webpack factory 87671. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { q: () => n });
  class n {
    constructor() {
      this.updateFinished();
    }
    get finished() {
      return this._finished;
    }
    updateFinished() {
      this._finished = new Promise((t) => {
        this.resolve = t;
      });
    }
    notifyFinished() {
      this.resolve();
    }
    then(t, e) {
      return this.finished.then(t, e);
    }
  }
}
